import PageNotFound from 'componets/page-not-found/page-not-found'

export default PageNotFound
